import { baseApiAxios } from './api';
import { displaySuccessPopup, displayErrorPopup } from './main';
import { addButtonSpinner, removeSpinners } from './sidebar';
import { Modal } from 'bootstrap';

export function getRowData(tableId, rowData) {
  if (typeof rowData === 'number') {
    const dt = $('#' + tableId).DataTable({ retrieve: true });
    return dt.row(rowData).data();
  } else if (typeof rowData === 'string') {
    return JSON.parse(rowData);
  }
  return rowData;
}

export function getDisableTarget(clickEvent, className) {
  const target = clickEvent.target;
  const button = target?.classList.contains(className) ? target : target?.closest(`button.${className}`);
  button.disabled = true;
  return button;
}

export function validateModalForm() {
  let isFormValid = true;
  const inputs = $('#sharedModalContent input, #sharedModalContent select').removeClass('is-invalid');

  for (const input of inputs.toArray()) {
    if (!input.value.trim() && input.required) {
      input.classList.add('is-invalid');
      isFormValid = false;
      continue;
    }

    // Enforce the native HTML5 `pattern` attribute (e.g. UUID format) against the raw, untrimmed
    // value, so leading/trailing/internal whitespace is rejected rather than silently accepted.
    if (input.value && input.pattern && !new RegExp(input.pattern).test(input.value)) {
      input.classList.add('is-invalid');
      isFormValid = false;
    }
  }

  return isFormValid;
}

export async function submitModalOrder(modal, buttonId, orderPayload, successMessage) {
  addButtonSpinner(buttonId);
  try {
    const { order_id } = await baseApiAxios.createOrder(orderPayload);
    removeSpinners();
    Modal.getInstance(modal).hide();
    displaySuccessPopup(successMessage.replace('{order_id}', order_id), 'Order Submitted');
  } catch (e) {
    Modal.getInstance(modal).hide();
    removeSpinners();
    const errMessage = Array.isArray(e.response?.data?.errors) ? e.response.data.errors[0] : e.message;
    displayErrorPopup(e, errMessage);
  }
}

export function FormField({ id, label, name, ...inputProps }) {
  // NOSONAR - custom JSX runtime, no propTypes
  return (
    <div class="form-group row">
      <label for={id} class="col-md-12 col-lg-3 col-xl-2 form-label-text">
        {label}
      </label>
      <div class="col-md-12 col-lg-9 col-xl-10">
        <input type="text" id={id} name={name || id} class="form-control" {...inputProps} />
      </div>
    </div>
  );
}
